import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLocale } from '@/i18n';

/**
 * Keeps the document's title, description, canonical, robots, social tags and structured data in
 * step with the route and the language. Mounted once, beside the router's routes, so no page has
 * to remember to do it.
 *
 * The work is in ./runtime, loaded after first paint: a visitor who lands on a public page
 * already has the right tags from its static HTML, and the signed-in app's shell is already
 * noindex, so nothing here is worth a byte of the first-paint budget.
 */
export const RouteSeo = () => {
  const { pathname } = useLocation();
  const { locale } = useLocale();

  useEffect(() => {
    let stale = false;
    void import('./runtime')
      .then((m) => m.prepareSeo(pathname, locale))
      .then((apply) => {
        if (!stale) apply();
      })
      // Offline, or a deploy mid-visit: the page still works with the tags it has.
      .catch(() => undefined);
    return () => {
      stale = true;
    };
  }, [pathname, locale]);

  return null;
};
